class Comments {

  constructor() {

    if (!this.setVars())
      return

    this.setEvents()

  }

  setVars() {

    this.section = document.querySelector('.comments')

    if (!this.section)
      return

    this.buttons = this.section.querySelectorAll('.comments__like')
    this.comments = this.section.querySelectorAll('.comments__item')
    this.pagination = this.section.querySelectorAll('.comments__pagination')

    return true

  }

  setEvents() {

    this.buttons.each((item) => {

      item.addEventListener('click', (e) => {

        e.preventDefault()
        this.saveVote(e.currentTarget)

      })

    })

    this.comments.each(comment => {
      const responses = comment.querySelector('.comments__responses')
      const deleteButton = comment.querySelector('.comments__delete')
      const replyButton = comment.querySelector('.comments__reply')

      if (responses) {
        responses.addEventListener('click', (e) => {
          e.preventDefault()
          this.toggleResponses(responses, comment)
        })
      }

      if (deleteButton) {
        deleteButton.addEventListener('click', (e) => {
          e.preventDefault()
          //this.deleteComment()
        })
      }

      if (replyButton) {
        replyButton.addEventListener('click', (e) => {
          e.preventDefault()
          //this.replyToComment()
        })
      }
    })

    this.setPaginationEvents()

  }

  setPaginationEvents() {

    const prevArrow = this.section.querySelectorAll('.comments__paginationArrow--left')
    const nextArrow = this.section.querySelectorAll('.comments__paginationArrow--right')
    const headerPages = this.section.querySelectorAll('.comments__header .comments__paginationItem')
    const footerPages = this.section.querySelectorAll('.comments__footer .comments__paginationItem')

    const pageChangeFunction = (e, i, page) => {
      e.preventDefault()

      if (page.hasClass('comments__paginationItem--active'))
        return;

      let activePage = 0
      headerPages.each((page, index) => {
        if (page.hasClass('comments__paginationItem--active'))
          activePage = index
      });
      headerPages[activePage].removeClass('comments__paginationItem--active')
      footerPages[activePage].removeClass('comments__paginationItem--active')
      headerPages[i].addClass('comments__paginationItem--active')
      footerPages[i].addClass('comments__paginationItem--active')
    }

    prevArrow.each(arrow => {
      arrow.addEventListener('click', (e) => {
        e.preventDefault()
        let activePage = 0
        headerPages.each((page, index) => {
          if (page.hasClass('comments__paginationItem--active'))
            activePage = index
        });

        if (activePage == 0) {
          return;
        }

        headerPages[activePage].removeClass('comments__paginationItem--active')
        headerPages[activePage - 1].addClass('comments__paginationItem--active')
        footerPages[activePage].removeClass('comments__paginationItem--active')
        footerPages[activePage - 1].addClass('comments__paginationItem--active')
      })
    })

    nextArrow.each(arrow => {
      arrow.addEventListener('click', (e) => {
        e.preventDefault()

        let activePage = 0
        headerPages.each((page, index) => {
          if (page.hasClass('comments__paginationItem--active'))
            activePage = index
        });

        if (activePage == headerPages.length - 1) {
          return;
        } else {
          headerPages[activePage].removeClass('comments__paginationItem--active')
          headerPages[activePage + 1].addClass('comments__paginationItem--active')
          footerPages[activePage].removeClass('comments__paginationItem--active')
          footerPages[activePage + 1].addClass('comments__paginationItem--active')
        }
      })
    })

    headerPages.each((page, i) => {
      page.addEventListener('click', (e) => {
        pageChangeFunction(e, i, page);
      })
    })

    footerPages.each((page, i) => {
      page.addEventListener('click', (e) => {
        pageChangeFunction(e, i, page);
      })
    })

  }

  saveVote(button) {

    const wrapper = button.parentNode;
    var comment_id = button.getAttribute('data-comment-id');
    var type = button.getAttribute('data-type');

    $.getJSON('/voteForComment?comment_id='+comment_id+'&type='+type, function(data) {
        if (data.status == 'error') {
            alert(data.message);
            wrapper.addClass('comments__likes--disabled');
            button.addClass('comments__like--active');
        }
        else {
            wrapper.addClass('comments__likes--disabled');
            button.addClass('comments__like--active');
            button.innerHTML = data.points;
            setCookie('cv_'+comment_id, 1, 365);
        }
    });
  }

  toggleResponses(responseButton, comment) {

    const isCollapsed  = responseButton.hasClass('comments__responses--inactive')

    if (isCollapsed) {
      comment.removeClass('comments__item--collapsed')
      responseButton.removeClass('comments__responses--inactive')
    } else {
      comment.addClass('comments__item--collapsed')
      responseButton.addClass('comments__responses--inactive')
    }

  }

  deleteComment() {

    document.body.bindCustomEvent('open-popup', 'comment-delete')

  }

  replyToComment() {

    document.body.bindCustomEvent('open-popup', 'comment-reply')

  }
}
